import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

const LEGACY_STATUS_OPTIONS = [
  {
    id: "ACTION_REQUIRED",
    name: "Action required",
  },
  {
    id: "CANCELLED",
    name: "Cancelled",
  },
  {
    id: "COMPLETE",
    name: "Complete",
  },
  {
    id: "IN_DISPUTE",
    name: "In dispute",
  },
  {
    id: "IN_PROGRESS",
    name: "In progress",
  },
  {
    id: "WAITING_ON_CANDIDATE",
    name: "Waiting on candidate",
  },
  {
    id: "APPLICATION_EXPIRED",
    name: "Application expired",
  },
];

export function LegacyStatusFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.status?.split(",") || []}
      onSelectionChange={(keys) => setParam("status", Array.from(keys))}
      label={t("Status")}
      items={LEGACY_STATUS_OPTIONS}
      selectionMode="multiple"
      testID="legacy-status-filter"
    />
  );
}
